import { render, staticRenderFns } from "./BuyerInput.vue?vue&type=template&id=72f5b148&lang=pug&"
import script from "./BuyerInput.vue?vue&type=script&lang=js&"
export * from "./BuyerInput.vue?vue&type=script&lang=js&"
import style0 from "./BuyerInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f5b148')) {
      api.createRecord('72f5b148', component.options)
    } else {
      api.reload('72f5b148', component.options)
    }
    module.hot.accept("./BuyerInput.vue?vue&type=template&id=72f5b148&lang=pug&", function () {
      api.rerender('72f5b148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/BuyerInput.vue"
export default component.exports